<template>
    <select
        class="form-control select2"
        :multiple="multiple"
        :required="required"
        :data-placeholder="placeholder"
        style="width: 100%;"
    >
        <option v-if="!multiple" value=""></option>
        <option
            v-for="opt in options"
            :key="opt.value"
            :value="opt.value"
        >{{ opt.text }}</option>
    </select>
</template>

<script>
export default {
    name: 'Select2',
    props: {
        options: { type: Array, default: () => [] },
        value: { default: null },
        placeholder: { type: String, default: 'Seleccione' },
        multiple: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
    },
    data() {
        return { initialized: false };
    },
    mounted() {
        this.waitForSelect2().then(() => this.initSelect2());
    },
    beforeDestroy() {
        if (this.initialized && window.$ && this.$el) {
            window.$(this.$el).off().select2('destroy');
        }
    },
    watch: {
        value(newVal) {
            if (!this.initialized) return;
            const $el = window.$(this.$el);
            const current = $el.val();
            const normalized = this.multiple
                ? (Array.isArray(newVal) ? newVal.map(String) : [])
                : (newVal == null ? '' : String(newVal));
            const currentNorm = this.multiple ? (current || []) : (current || '');
            if (JSON.stringify(currentNorm) !== JSON.stringify(normalized)) {
                $el.val(normalized).trigger('change.select2');
            }
        },
        options() {
            this.$nextTick(() => {
                if (!this.initialized || !window.$) return;
                const val = this.multiple
                    ? (Array.isArray(this.value) ? this.value.map(String) : [])
                    : (this.value == null ? '' : String(this.value));
                window.$(this.$el).val(val).trigger('change.select2');
            });
        }
    },
    methods: {
        waitForSelect2() {
            return new Promise((resolve) => {
                const check = () => {
                    if (window.$ && window.$.fn && window.$.fn.select2) {
                        resolve();
                    } else {
                        setTimeout(check, 50);
                    }
                };
                check();
            });
        },
        initSelect2() {
            const $el = window.$(this.$el);
            $el.select2({
                placeholder: this.placeholder,
                allowClear: !this.multiple,
                width: '100%',
                language: 'es',
            });

            const initial = this.multiple
                ? (Array.isArray(this.value) ? this.value.map(String) : [])
                : (this.value == null ? '' : String(this.value));
            $el.val(initial).trigger('change.select2');

            $el.on('change', (e) => {
                const v = window.$(e.target).val();
                if (this.multiple) {
                    this.$emit('input', Array.isArray(v) ? v.map(x => isNaN(x) ? x : Number(x)) : []);
                } else {
                    this.$emit('input', v === '' ? null : (isNaN(v) ? v : Number(v)));
                }
            });

            this.initialized = true;
        }
    }
};
</script>
